import actionTypes from "../actions/action-types";
import {sendRequest, postData} from '../utils/request.js';
import http_build_query from "locutus/php/url/http_build_query";
import { push } from 'connected-react-router';
import {setFormValues,setPristineValues,setInitialValues,setFieldValue,setEditorConfig} from './editors';
import {setSelectorGridState} from './SelectorGrids';
import {setSelectorImageState} from './SelectorImages';
import {setBoxState} from './Boxes';
import {createMenu,toggleMenu,activeMenu,keepOpenedMenu} from './menu';
import {setPacePercent,endPace,startPace} from './pace';
import {loadState, saveState} from "../storage/localStorage";
import Cookies from 'universal-cookie';
import moment from 'moment';
import {loadComponent} from "../utils/components";

const cookies = new Cookies();

export const showModal = (props) => {
    return {type: actionTypes.SHOW_MODAL, properties: {state: "on", ...props}}
};
export const closeModal = (props) => {
    return {type: actionTypes.CLOSE_MODAL, properties: {state: "off", ...props}};
};
export const toggleSidebar = () => {
    return {type: actionTypes.TOGGLE_SIDEBAR};
};
export const setUser = (data) => {
    return {type: actionTypes.SET_USER, data};
};

export const setContent = (content, props = {}) => {
    return push('?' + http_build_query({option: content, ...props}));
    //return {type: actionTypes.SET_CONTENT, content, props};
};


export function loadMainMenu() {
    return async function (dispatch) {
        const data = await sendRequest({option: 'menu', filter: [{field: "token", value: "admin"}]});
        dispatch(createMenu(data.items));
    }
};

export function loginUser(cb) {
    return async function (dispatch) {
        const data = await sendRequest({option: 'currentuser', view: 'admin'});
        if (data.id !== null) {
            data.dispatch = true;
            dispatch(setUser(data));
            cb instanceof Function && cb();
        } else {
            dispatch(setUser({id: null, dispatch: true}));
            cb instanceof Function && cb();
        }
    }
};

export function logoutUser(cb) {
    return async function (dispatch) {
        const data = await postData({action: "currentuser.logoutuser"});
        if (data.success) {
            dispatch(setUser({id: null, dispatch: true}));
            if (cb instanceof Function) cb();
        }
    }
};

const setTill = (data) => {
    return {type: actionTypes.SET_TILL, data};
};

export function loadTill(till_id) {
    return async function (dispatch) {
        let load_till_id = till_id || ((till_id) => till_id === "undefined" ? undefined : till_id)(cookies.get("till_id"));
        if (load_till_id) {
            try {
                const data = await sendRequest({option: 'Till', id: load_till_id}, {showError: false});
                if (data.id !== null) {
                    saveState(data.id, "till_id");
                    //cookies.set("till_id", data.till_id, { path: '/admin', expires: moment().add(1, 'years').toDate() });
                    cookies.set("till_id", data.id, { path: '/', expires: moment().add(1, 'years').toDate() });
                    data.dispatch = true;
                    dispatch(setTill(data));
                } else {
                    dispatch(setTill({id: null, dispatch: true}));
                }
            } catch (e) {
                dispatch(setTill({id: null, dispatch: true}));
            }
        } else {
            const data = {dispatch: true};
            const context = await loadComponent("Context", {}, ["pos"]);
            if (context.pos) {
                data.pos = context.pos;
            }
            dispatch(setTill(data));
        }
    }
};

export function removeTill(cb) {
    return async function (dispatch) {
        const till_id = loadState("till_id");
        if (till_id) {
            const data = await postData({action: "Till.delete", id: till_id});
            if (data.success) {
                dispatch(setTill({id: null, dispatch: true}));
                if (cb instanceof Function) cb();
            }
        } else {
            dispatch(setTill({id: null, dispatch: true}));
            if (cb instanceof Function) cb();
        }
    }
};

function reduxStoreChanged(newState) {
    return {type: actionTypes.REDUX_STORE_CHANGED, payload: newState}
};

export {
    setFormValues,
    setPristineValues,
    setInitialValues,
    setFieldValue,
    setEditorConfig,
    setSelectorGridState,
    setSelectorImageState,
    setBoxState,
    createMenu,
    toggleMenu,
    activeMenu,
    keepOpenedMenu,
    setPacePercent,
    endPace,
    startPace,
    reduxStoreChanged
};